/**
 * ClinicalHUD 5 teaching profile.
 * Same listening-game workspace as ClinicalHUD 4. Sessions are stored in
 * clinicalHud5Teaching so an attempt here does not overwrite ClinicalHUD 3
 * or ClinicalHUD 4.
 */
import { HUD3_MODES } from "features/clinicalHud3/clinicalHud3Modes";
import {
  CLINICAL_HUD4_FINAL_CASE,
  CLINICAL_HUD4_TEACHING,
} from "features/clinicalHud4/clinicalHud4WorkspaceConfig";
import { CLINICAL_HUD5_TEACHING_PATH } from "./clinicalHud5Paths";

/** Scored Morning Report order. Unscored cases keep the ClinicalHUD 4 order. */
export const CLINICAL_HUD5_MODE_ORDER = Object.freeze([
  "case",
  "choice",
  CLINICAL_HUD4_FINAL_CASE,
  HUD3_MODES.DIAGNOSTICS,
  HUD3_MODES.TREATMENT,
  HUD3_MODES.PEARLS,
  HUD3_MODES.DISCHARGE,
  HUD3_MODES.DOCUMENTATION,
]);

export const CLINICAL_HUD5_TEACHING_COLLECTION = "clinicalHud5Teaching";

export const CLINICAL_HUD5_TEACHING = Object.freeze({
  ...CLINICAL_HUD4_TEACHING,
  product: "clinicalHud5",
  modeOrder: CLINICAL_HUD5_MODE_ORDER,
  productTitle: "MorningReport Cases",
  /** Faculty authoring surface display name (SCL-073). */
  facultyProductTitle: "MorningReport Cases (Faculty)",
  productTagline: "Powered by Medical SuperIntelligence™",
  collection: CLINICAL_HUD5_TEACHING_COLLECTION,
  listPath: CLINICAL_HUD5_TEACHING_PATH,
  /** Hybrid old-bank + MSI3 org bank (Phase 4). */
  caseSource: "hybrid",
  bannerText:
    "MorningReport Cases — listen, then name the differential. Simulated case. Do not enter real patient information.",
});
